import { duration } from "moment";
import { apiSlice } from "./apiSlice";

export const legalSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getAllLegal: builder.query({
            query: (params) => ({
                url: `LegalRegister`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["Legal"],
        }),


        getSingleLegalDetails: builder.query({
            query: ({ legalTracker, params }) => ({
                url: `LegalRegister/${legalTracker}`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),

        createLegal: builder.mutation({
            query: (reqBody) => ({
                url: `LegalRegister`,
                method: "POST",
                body: reqBody
            }),
            invalidatesTags: ["Legal"],
        }),

        updateLegal: builder.mutation({
            query: (reqBody) => ({
                url: `LegalRegister`,
                method: "PUT",
                body: reqBody
            }),
            invalidatesTags: ["Legal"],
        }),


        getAllLegalCount: builder.query({
            query: (params) => ({
                url: `LegalRegister/project/${params.projectId}/type-count`,
                params

            }),
        }),
         getExportAllLegal: builder.query({
            query: (params) => ({
                url: `LegalRegister`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),




    }),
});

export const {
    useLazyGetAllLegalQuery,
    useCreateLegalMutation,
    useUpdateLegalMutation,
    useGetAllLegalCountQuery,
    useGetSingleLegalDetailsQuery,
    useLazyGetExportAllLegalQuery


} = legalSlice;